import { isAppListedAsBundle, isBenefitApp, isNewVersionAvailable, isPendingApp, isSetupIncomplete, } from './appUtils';
import { ModalNames } from '../components/modals/modals';
import { getScaleToFillImageURL } from 'image-client-api/dist/imageClientSDK';
import { IncompleteSetupReason } from '@wix/ambassador-devcenter-managedapps-v1-managed-app/types';
export const newEnrichBundleApps = (bundleApps, installedApps) => {
    return bundleApps
        ? Array.from(bundleApps, (app) => newEnrichBundleApp(app, installedApps))
        : [];
};
export const enrichBenefitApp = (benefitApp, installedApps) => {
    const installedApp = installedApps.find((app) => app.appId === benefitApp.appId);
    if (installedApp) {
        return {
            ...benefitApp,
            ...installedApp,
        };
    }
    return benefitApp;
};
//
const newEnrichBundleApp = (bundleApp, installedApps) => {
    if (bundleApp?.upgradeSuggestion) {
        // app is installed
        const installedApp = installedApps.find((app) => app.appId === bundleApp.webSolutionBase.id);
        const enrichedBundleApp = {
            ...bundleApp,
            ...installedApp,
        };
        return enrichedBundleApp;
    }
    const enrichedBundleAppNotInstalled = {
        ...bundleApp,
        appId: bundleApp?.webSolutionBase.id,
        appInfo: {
            name: bundleApp?.webSolutionBase.name,
            icon: bundleApp?.webSolutionBase.icon,
            teaser: bundleApp?.webSolutionBase.teaser,
            slug: bundleApp?.webSolutionBase.slug,
            publishedVersion: bundleApp.publishedVersion,
            openConsentIn: bundleApp.webSolutionBase.openConsentIn,
        },
    };
    return enrichedBundleAppNotInstalled;
};
export const newGetAppsRequiredPremium = (siteIsPremium, installedApps) => {
    return siteIsPremium
        ? []
        : installedApps.filter((app) => app.premiumInfo.requiresWixPremium &&
            app.premiumInfo.eligibleForUpgrade);
};
export const getCompleteSetupApps = (installedApps, bundleApps, siteIsPremium, experiments, isDayfulFlow, benefitApps) => {
    if (!installedApps) {
        return;
    }
    const isBenefitsAppExperimentEnabled = experiments.enabled('specs.app-market.AppBenefits');
    const pendingApps = installedApps.filter((app) => !isBenefitApp(app.appId, benefitApps) &&
        !isAppListedAsBundle(app.appId, bundleApps) &&
        isPendingApp(app) &&
        !isNewVersionAvailable(app));
    const appsWithNewVersionAvailable = installedApps.filter((app) => !isBenefitApp(app.appId, benefitApps) &&
        !isAppListedAsBundle(app.appId, bundleApps) &&
        isNewVersionAvailable(app));
    const setupIncompleteApps = installedApps.filter((app) => !isBenefitApp(app.appId, benefitApps) &&
        !isNewVersionAvailable(app) &&
        !isAppListedAsBundle(app.appId, bundleApps) &&
        isSetupIncomplete(app));
    const { installedBundleBenefitApps, nonInstalledBundleBenefitApps } = [...bundleApps, ...benefitApps].reduce((acc, app) => {
        // checking upgradeSuggestion is relevant only for bundle apps
        if (app.upgradeSuggestion || app?.installationDetails?.group === 'INSTALLED') {
            acc.installedBundleBenefitApps.push(app);
        }
        else {
            acc.nonInstalledBundleBenefitApps.push(app);
        }
        return acc;
    }, { installedBundleBenefitApps: [], nonInstalledBundleBenefitApps: [] });
    if (isDayfulFlow) {
        return setupIncompleteApps.concat(appsWithNewVersionAvailable);
    }
    return pendingApps
        .concat(setupIncompleteApps)
        .concat(installedBundleBenefitApps)
        .concat(appsWithNewVersionAvailable)
        .concat(newGetAppsRequiredPremium(siteIsPremium, installedApps))
        .concat(nonInstalledBundleBenefitApps)
        .filter((x, i, a) => a.indexOf(x) === i)
        .filter((x) => x?.installationDetails?.incompleteSetupReason !==
        IncompleteSetupReason.PENDING_REQUIRED_INSTALLATIONS);
};
export const getDeepLink = (deepLinkData, installedApps) => {
    if (deepLinkData && deepLinkData.modal === 'delete' && deepLinkData.appId) {
        const installedApp = installedApps.find((app) => {
            const appId = app?.appId ??
                app?.webSolutionBase.id;
            return appId === deepLinkData.appId;
        });
        if (installedApp) {
            return {
                openModal: ModalNames.DELETE,
                modalProps: {
                    openModalName: ModalNames.DELETE,
                    app: installedApp,
                },
            };
        }
    }
    return {};
};
export const filterDismissedBundleApps = (apps) => {
    return apps
        ? apps.filter((app) => {
            const localStorageData = localStorage.getItem(`dismissed-${app.webSolutionBase.id}`);
            return localStorageData !== 'dismissed';
        })
        : [];
};
export const businessSolutionAppsToFilter = [
    '1380b703-ce81-ff05-f115-39571d94dfcd',
    '13d21c63-b5ec-5912-8397-c3a5ddb27a97',
    '140603ad-af8d-84a5-2c80-a0f60cb47351',
    '1522827f-c56c-a5c9-2ac9-00f9e6ae12d3',
    '14bcded7-0066-7c35-14d7-466cb3f09103',
    '14724f35-6794-cd1a-0244-25fd138f9242',
    '13e8d036-5516-6104-b456-c8466db39542',
    '148c2287-c669-d849-d153-463c7486a694',
    '14ce1214-b278-a7e4-1373-00cebd1bef7c',
    '2936472a-a1ed-4ae5-9f71-614313a9f4e7',
    '14cc59bc-f0b7-15b8-e1c7-89ce41d0e0c9',
    '13ff8629-c1fc-e289-e81f-bc8c8968e9d6',
    '14409595-f076-4753-8303-9a86f9f71469',
    '14517e1a-3ff0-af98-408e-2bd6953c36a2',
    '1484cb44-49cd-5b39-9681-75188ab429de',
    '215238eb-22a5-4c36-9e7b-e7c08025e04e',
];
export const filterBusinessSolutionApps = (installedApps = []) => {
    return installedApps.filter((app) => !businessSolutionAppsToFilter.includes(app.appId));
};
const getURI = (iconURL) => iconURL && iconURL.split('/').pop();
export const getClientImageURL = (iconURL, options) => {
    const { originalWidth, originalHeight, toWidth, toHeight } = options;
    return getScaleToFillImageURL(getURI(iconURL), originalWidth, originalHeight, toWidth, toHeight);
};
//# sourceMappingURL=utils.js.map